export default "__VITE_ASSET__BMek3PSg__"